import React from "react";

import {
    BrowserRouter as Router,
    Switch,
    Route,
} from "react-router-dom";

import Main from './pages/Main';
import ProvideAuth, {PrivateRoute} from './authprovider'
import LoginPage from "./pages/LoginPage";
import ControllRoom from './pages/control/Controll';
import BuildingPage from "./pages/building/BuildingPage";
import VideosPage from "./pages/videos/VideoPage";
import packageJson from '../package.json';
import FilesManager from "./pages/control/FilesManager";
import CalendarView from "./pages/calendar/CalendarView";
import UsersPage from "./pages/control/UsersPage";

export default function ServeApp() {


    return (
        <ProvideAuth>
            <Router>
                    <Switch>
                        <Route path="/login">
                            <LoginPage />
                        </Route>
                        <PrivateRoute path="/controll">
                            <ControllRoom />
                        </PrivateRoute>
                        <PrivateRoute path="/files">
                            <FilesManager />
                        </PrivateRoute>
                        <PrivateRoute path="/users">
                            <UsersPage />
                        </PrivateRoute>
                        <PrivateRoute path="/videos">
                            <VideosPage />
                        </PrivateRoute>
                        <PrivateRoute path="/building">
                            <BuildingPage />
                        </PrivateRoute>
                        <PrivateRoute path="/*">
                            <Main />
                        </PrivateRoute>
                    </Switch>
            </Router>
        </ProvideAuth>
    );
}





// A wrapper for <Route> that redirects to the login
// screen if you're not yet authenticated.


